export const MASTER_ENDPOINT = {
  AcceptJob: 'jobs/accept',
  Admins: 'users',
  Candidates: 'candidates',
  Changepassword: 'password/change',
  Clients: 'clients',
  CloseJobs: 'jobs/close',
  Consultants: 'consultants',
  Customer: 'customer',
  CustomerBeeline: 'customer/beeline',
  EmailValidate: 'auth/email-validation',
  EmlFiles: 'jobs/read/eml',
  Files: 'files',
  ForgotPassword: 'password/forgot',
  IpWhiteList: 'ip-white-list',
  JobConfig: 'master/job-config',
  JobPostingAssign: 'job-postings/assign',
  JobQueue: 'job-queue',
  JobSources: 'master/job-sources',
  Jobs: 'job-postings',
  LeaveTypes: 'master/leave-types',
  Leaves: 'leave',
  LeavesStatus: 'leave/status',
  Login: 'auth/login',
  LogoutUrl: 'auth/logout',
  MatchedCandidate: 'candidates/list',
  Organization: 'master/organization',
  Payperiods: 'payperiods',
  ProjectsConsultant: 'projects/project-consultant',
  Queue: 'queues',
  Roles: 'master/roles',
  SetPassword: 'password/set-password',
  Skills: 'skills',
  SseSubscribe: 'events/subscribe',
  SsoLogin: 'auth/sso/login',
  Teams: 'teams',
  ValidateHash: 'password/validate',
  VersionHistory: 'version-history',
  WorkStatus: 'master/work-status',
};

export const TIMESHEET = {
  Notification: 'notifications',
  TimeSheetNotesCreate: 'timesheets/notes',
  TimeSheetnotes: 'timesheets/timesheets-notes',
  TimeSheets: 'timesheets',
  TimeSheetsHours: 'timesheets/hours',
};

export const PAYSHEET: any = {
  Payroll: 'payroll',
};
export const RESUME_ENDPOINT = {
  ResumeValidation: 'resume-validation/upload',
  ResumeValidationDocumentTypes: 'resume-validation/document-type',
  ResumeValidationGetAnalytical: 'resume-validation/analytics',
  ResumeValidationLinkedInValidation: 'resume-validation/linkedin/verify',
  ResumeValidationMatchingProfile: 'resume-validation/matching-profiles',
  ResumeValidationParsed: 'resume-validation/parsed',
  ResumeValidationResumes: 'resume-validation/resumes',
  ResumeValidationSave: 'resume-validation',
  ResumeValidationStatus: 'resume-validation/status',
  ResumeValidationUsers: 'resume-validation/users',
  ResumeValidationsources: 'resume-validation/sources',
};

export const SALES_ENDPOINT = {
  EmailCampaign: 'jobs/email-campaign/resume',
  JobBoard: 'jobs/job-board/search',
  JobBoardBoolean: 'jobs/job-board/boolean',
  JobBoardResetBoolean: 'jobs/job-board/reset-boolean',
  JobBoardResults: 'jobs/job-board/search-raw',
  JobBoardScoreInitiate: 'jobs/job-board/score-initiate',
  JobBoardSearchInitiate: 'jobs/job-board/search-initiate',
  MatchedCandidates: 'jobs/candidates',
  SHORTLIST: 'jobs/candidates/shortlist',
};
